<template>
    <component :is="type" class="parallax">
        <slot/>
    </component>
</template>

<script>
import Scroll from '@/pure/Scroll'
import Resize from '@/pure/Resize'
import { getPosition } from '@/pure/position'

export default {
    props: {
        transform: { type: String, default: '' },
        power: { type: Number, default: -0.1 },
        effect: { type: String, default: 'translateY' },
        type: { type: String, default: 'span' }
    },

    mounted() {
        this.scroll = new Scroll()
        this.resize = new Resize()
        this.resize.addOnResized(this.setData)
        this.lastTransform = this.transform
        this.isInside = false

        this.$nextTick(this.setData)
        this._raf = requestAnimationFrame(this.onEnterFrame)
    },
    activated() {
        this.scroll = new Scroll()
        this.resize = new Resize()
        this.resize.addOnResized(this.setData)
        this.lastTransform = this.transform
        this.isInside = false

        this.$nextTick(this.setData)
        this._raf = requestAnimationFrame(this.onEnterFrame)

    },
    deactivated() {
        this.resize.removeOnResized(this.setData)
        cancelAnimationFrame(this._raf)

    },

    destroyed() {
        this.resize.removeOnResized(this.setData)
        cancelAnimationFrame(this._raf)
    },

    methods: {
        onEnterFrame() {
            this._raf = requestAnimationFrame(this.onEnterFrame)
            this.setTransform()
        },

        setTransform() {
            const scrollMiddle = this.scroll.y + this.resize.height / 2
            const objectMiddle = this.top + this.height / 2
            const gap = scrollMiddle - objectMiddle
            const y = gap * this.power
            const transform = this.effect + '(' + y.toFixed(1) + 'px)'
            const isInside = Math.abs(gap) - this.height / 2 < this.resize.height
            if (isInside) {
                if (!this.isInside) {
                    this.$el.style.willChange = 'transform'
                }
                const newTransform = this.transform + ' ' + transform
                if (newTransform !== this.lastTransform) {
                    this.$el.style.transform = newTransform
                    this.lastTransform = newTransform
                }
            } else {
                if (this.isInside) {
                    this.$el.style.willChange = ''
                }
            }
            this.isInside = isInside
        },

        setData() {
            this.$el.style.transform = this.transform
            this.top = getPosition(this.$el)[1]
            this.height = this.$el.offsetHeight
            this.$el.style.transform = this.lastTransform
        }
    }
}
</script>

<style lang="sass" scoped>
.parallax
    display: block
</style>
